
<main-form-modal (toggleChange)="setVal($event)"> 
    <ng-template #customHtmlElements>
        <div [ngSwitch]="editMode">
           
            <vouchersOrgPaymentPack-edit *ngSwitchCase="true"></vouchersOrgPaymentPack-edit>
            <vouchersOrgPaymentPack-details *ngSwitchCase="false"></vouchersOrgPaymentPack-details>
        </div>
    </ng-template>  
</main-form-modal>